async function devtricker_fetch_post(postId) {
    try {
        const url = new URL('/wp-admin/admin-ajax.php', window.location.origin);
        url.searchParams.append('action', 'devtricker_action_get_post_ajax');
        url.searchParams.append('post_id', postId);

        const response = await fetch(url, {
            method: 'GET',
            credentials: 'same-origin'
        });

        const result = await response.json();

        if (result.error) {
            console.error('Error fetching post:', result.error);
            return null;
        }

        console.log('Post data:', result);
        return result;
    } catch (error) {
        console.error('Failed to fetch post:', error);
        return null;
    }
}

async function devtricker_post_uploadImage(file) {

    const path = window.location.pathname;
    const segments = path.split('/');
    let postId = segments[2] || 0;

    if (postId == 0) {
        throw new Error("Invalid PostId");
    }

    const formData = new FormData();
    formData.append('nonce', await devtricker_process_getDevtrickerNonce());
    formData.append('image', file);
    formData.append('post_id', postId);
    formData.append('name', "aasds-dhsgdjs-sdi-asd");
    formData.append('action', 'devtricker_image_upload_ajax');

    const uploadUrl = '/wp-admin/admin-ajax.php';

    const response = await fetch(uploadUrl, {
        method: 'POST',
        body: formData
    });

    if (!response.ok) {
        throw new Error('Network response was not ok');
    }

    const result = await response.json();
    if (result.success) {
        return result.data.url;
    } else {
        const progress = document.querySelector(".image-upload-progress");

        if (progress) {
            progress.textContent = "Error uploading the image";
            progress.errorOccurred = true;
            const spinner = progress.previousElementSibling;
            spinner.remove();
        }

        throw new Error(result.message || 'Error uploading the image');
    }
}

async function devtricker_uploadPostThumbnail(file) {

    const captionInput = document.getElementById('thumbnailCaptionInput');

    const path = window.location.pathname;
    const segments = path.split('/');
    const postId = segments[2] || 0;

    const formData = new FormData();
    formData.append('nonce', await devtricker_process_getDevtrickerNonce());
    formData.append('thumbnail', file);
    formData.append('post_id', postId);
    formData.append('action', 'devtricker_set_post_thumbnail_ajax');
    formData.append('caption', captionInput.innerHTML);
    formData.append('image_changed', g_devtricker_imageChanged);
    formData.append('is_to_remove', g_devtricker_remove_thumbnail);
    formData.append('thumb_display_position', g_devtricker_thumb_display_position);

    const uploadUrl = '/wp-admin/admin-ajax.php';

    const response = await fetch(uploadUrl, {
        method: 'POST',
        body: formData
    });

    if (!response.ok) {
        throw new Error('Network response was not ok');
    }

    const result = await response.json();

    console.log("Resultado: " + JSON.stringify(result));

    if (result.success) {
        console.log('Upload successful:', JSON.stringify(result));
        return result.data;
    } else {
        console.error('Error from server:', result.data);
        throw new Error(result.data.message || 'Error uploading the thumbnail');
    }
}

async function devtricker_getPostThumbnail() {
    const path = window.location.pathname;
    const segments = path.split('/');
    const postId = segments[2] || 0;

    const url = new URL('/wp-admin/admin-ajax.php', window.location.origin);
    url.searchParams.append('post_id', postId);
    url.searchParams.append('action', 'devtricker_get_post_thumbnail_ajax');

    const response = await fetch(url, {
        method: 'GET',
        credentials: 'same-origin'
    });

    if (!response.ok) {
        throw new Error('Network response was not ok');
    }

    const result = await response.json();
    if (result.success && result.data.has_thumbnail) {
        return result.data;
    } else if (result.success && !result.data.has_thumbnail) {
        return null;
    } else {
        throw new Error(result.message || 'No thumbnail found for this post');
    }
}

async function devtricker_removePostThumbnail(postId) {
    const formData = new FormData();
    formData.append('nonce', await devtricker_process_getDevtrickerNonce());
    formData.append('post_id', postId);
    formData.append('action', 'devtricker_remove_post_thumbnail');

    const removeUrl = '/wp-admin/admin-ajax.php';

    const response = await fetch(removeUrl, {
        method: 'POST',
        body: formData
    });

    if (!response.ok) {
        throw new Error('Network response was not ok');
    }

    const result = await response.json();

    console.log("Resultado: " + JSON.stringify(result));

    if (result.success) {
        console.log('Thumbnail removed successfully:', JSON.stringify(result));
        return result.data;
    } else {
        console.error('Error from server:', result.data);
        throw new Error(result.data.message || 'Error removing the thumbnail');
    }
}